module.exports = __webpack_public_path__ + "static/media/cap2-03-desk.c15782cc.png";